export default "__VITE_ASSET__DQFLbkQI__"